import { QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { QcdefectitemEntity } from "./dto/qc-defect-items-entity";
@Entity('qc_defect_details')
export class QcDefect{
    @PrimaryGeneratedColumn("increment",{name:'qc_id'})
    qcId:number;

    @Column("varchar", {
        length: 50,
        name: "lot_number"
      })
      lotNumber: string;

      @Column('int', {
        name: "workstation_id"
      })
      workstationId: number;

      @CreateDateColumn({
        name: "start_time",
        type: "datetime"
      })
      startTime: Date;

    @Column({type:'int',
     name:"operation_id",
    })
    operationId:number

     @Column('int',{
      name:"inspected_count"
   })
   inspectedCount:number;

   @Column('int',{
    name:"inspected_quantity"
   })
   inspectedQuantity:number;

   @Column('int',{
    name:"passed_quantity"
   })
   passedQuantity:number;


   @OneToMany(type => QcdefectitemEntity,defectitems =>defectitems.qcdefectdetailsinfo, {cascade:true})
  qcdefectItems:QcdefectitemEntity[];

   @Column("varchar", {
   name: "test_result",
   nullable: true,
    })
   testResult: string;

   @Column("varchar", {
        name: "remarks",
        nullable: true,
      })
   remarks: string;
     
  @Column("boolean", {
   nullable: false,
   default: true,
    name: "is_active"
   })
   isActive: boolean;
      
  @CreateDateColumn({
  name: "created_at",
  type: "datetime"
  })
   createdAt: Date;
    
 @Column("varchar", {
  nullable: true,
  name: "created_user"
   })
   createdUser: string | null;
    
  @UpdateDateColumn({
   name: "updated_at",
   type: 'datetime'
     })
  updatedAt: Date;
    
  @Column("varchar", {
  nullable: true,
  name: "updated_user"
   })
  updatedUser: string | null;

   @Column("int",{
   name:"unit_id"
    })
  unitId:number
    
  @VersionColumn({
  default: 1,
   name: "version_flag"
   })
   versionFlag: number;

}